// extracted by mini-css-extract-plugin
export var displayNone = "_r3-6";
export var imgContainer = "_r3-2";
export var overflowHidden = "_r3-3";
export var productInfoCardButtonContainer = "_r3-5";
export var productTitleText = "_r3-4";
export var rightArrow = "_r3-1";
export var rightArrowContainer = "_r3-0";